import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
Vue.use(Vuex);

//import router from "../router";

export default new Vuex.Store({
  state: {
    svivaNiturAirList: [],
    setlTypes: null,
    pointIndex: undefined,
    myChart: null,
    allData: [],
    graphData: [],
    base_level: null,
    base_level_id: null,
    base_name: null,
    base_id: null,
    wkt: null,
    polygonSetlCode: null,
    polygonIds: [],
    mapSelectionType: null,
    recaptchaToken: null,
    userLimitModal: false,
    contactModal: false,
    selectedTab: 'all',
    apiUrlBase: "https://keo2uppakf.execute-api.il-central-1.amazonaws.com/prod",
    userToken: null,
    userTokenType: null,
    verifyToken: null,
    currentUser: null,
    password: null,
    username: null,
    useremail: null,
    userid: null,
    showLogin: false,
    showMap: false,
    extendMap: false,
    mapStatus: 0,
    mapSelectionAllowed: false,
    neigh_comp_search: "",
    addr_comp_search: "",

    view: '',
    storeObject: null,

    prevPath: null,
    loading: false,
    mapCreated: false,
    searchError: false,
    neig_searchError: false,
    neigh: null,
    graphData_rooms: null,
    config: {},
    s3_url: "https://d1pbgh6hzbn1h3.cloudfront.net/backgroundMaps/03_01_2024/",
    s3_page_base:
      "https://d1pbgh6hzbn1h3.cloudfront.net/backgroundMaps/03_01_2024/pages",
    s3_deals_base:
      "https://d1pbgh6hzbn1h3.cloudfront.net/backgroundMaps/03_01_2024/deals/",
    s3_rents_base:
      "https://d1pbgh6hzbn1h3.cloudfront.net/backgroundMaps/03_01_2024/rents/",
    setl_url: "settlement/",
    neigh_url: "neighborhood/",
    street_url: "street/",
    asset_url: "asset/",
    kparcel_url: "kparcel_all/",
    setlCode: null,
    neighborhoodId: null,
    streetCode: null,
    streetName: null,
    houseNumber: null,
    addressId: null,
    addrName: null,
    X: 0,
    Y: 0,
    neighborhoodName: null,
    settlementName: null,
    clickedNeighborhoodName: null,
    clickedRentPrice: null,
    clickedRentPrice_3: null,
    clickedRentPrice_4: null,
    clickedRentPrice_5: null,
    current: 1,
    total: 0,
    ResultType: "",
    deals: [],
    additionalDeals: [],
    additional_total: 0,
    similarNeighborhoods: [],
    similarStreets: [],
    search: "",
    isMain: true,
    searchType: null,
    searchTypeText: null,
    ResultLabel: null,
    luxury: null,
    priceIncreases: null,
    Yield: null,
    lastYearAvgPrice: null,
    lastYearAvgPrice_3: null,
    lastYearAvgPrice_4: null,
    lastYearAvgPrice_5: null,
    lastQuarterlyAvgPrice: null,
    lastYearAvgSetlPrice: null,
    lastQuarterlyAvgPrice_3: null,
    lastQuarterlyAvgPrice_4: null,
    lastQuarterlyAvgPrice_5: null,
    priceDifferencePercentage: null,
    priceDifferencePercentage_3: null,
    priceDifferencePercentage_4: null,
    priceDifferencePercentage_5: null,

    info: null,
    featuresIds: [],
    selectedNearByObject: {
      id: 1,
      title: "גנים ובתי ספר",
      mapLayerName: "kidsGardensAndSchools",
      showSubLayers: false,
      children: [
        {
          id: 11,
          title: "הכל",
          mapLayerName: "all",
        },
        {
          id: 12,
          title: "גני עירייה",
          mapLayerName: "municipalGardens",
        },
        {
          id: 13,
          title: "גנים פרטיים",
          mapLayerName: "privateGardens",
        },
        {
          id: 14,
          title: "בית ספר יסודי",
          mapLayerName: "elementarySchools",
        },
        {
          id: 15,
          title: "חטיבת בינייים",
          mapLayerName: "juniorHigh",
        },
        {
          id: 16,
          title: "תיכון",
          mapLayerName: "highSchools",
        },
      ],
    },


    // 1 'גנים ובתי ספר'
    // 2 'תחבורה ציבורית'
    // 3 'גינות בסביבה'
    // 4 'סידורים בסביבה'
    // 5 'תרבות וקהילה'
    // 6 'איכות הסביבה'
  
    nearByMenu: [
      {
        id: 1,
        buttonClicked: true,
        title: "גנים ובתי ספר",
        mapLayerName: "kidsGardensAndSchools",
        showSubLayers: false,
        children: [
          {
            id: 11,
            title: "הכל",
            mapLayerName: "all",
          },
          {
            id: 12,
            title: "גני עירייה",
            mapLayerName: "municipalGardens",
            layerIcon: "kidgarden",


          },
          {
            id: 13,
            title: "גנים פרטיים",
            mapLayerName: "privateGardens",
            layerIcon: "kidgarden",

          },
          {
            id: 14,
            title: "בית ספר יסודי",
            mapLayerName: "elementarySchools",
            layerIcon: "schools",
          },
          {
            id: 15,
            title: "חטיבת בינייים",
            mapLayerName: "juniorHigh",
            layerIcon: "schools",
          },
          {
            id: 16,
            title: "תיכון",
            mapLayerName: "highSchools",
            layerIcon: "schools",
          },
        ],
      },
      {
        id: 2,
        buttonClicked: false,
        title: "תחבורה ציבורית",
        mapLayerName: "busStations",
        layerIcon : "busStop",
        showSubLayers: false,
      },
      {
        id: 3,
        buttonClicked: false,
        title: "גינות בסביבה",
        mapLayerName: "gardensAndParks",
        layerIcon : "gardensAndParks",
        showSubLayers: false,
      },
      {
        id: 4,
        buttonClicked: false,
        title: "סידורים בסביבה",
        mapLayerName: "arrangements",
        showSubLayers: false,
        children: [
          {
            id: 41,
            title: "הכל",
            mapLayerName: "all",
          },
          {
            id: 42,
            title: "בתי מרקחת",
            mapLayerName: "pharmacies",
            layerIcon : "pharmacies",
          },
          {
            id: 43,
            title: "מרכזים מסחריים",
            mapLayerName: "stores",
            layerIcon : "stores",
          },
        ],
      },
      {
        id: 5,
        buttonClicked: false,
        title: "תרבות וקהילה",
        mapLayerName: "community",
        showSubLayers: false,
        children: [
          {
            id: 51,
            title: "הכל",
            mapLayerName: "all",
          },
          {
            id: 52,
            title: "מרפאות",
            mapLayerName: "clinics",
            layerIcon : "clinics",
          },
          {
            id: 53,
            title: "מתנסים",
            mapLayerName: "centers",
            layerIcon : "centers",
          },
          {
            id: 54,
            title: "מרכזים דתיים",
            mapLayerName: "religionPoints",
            layerIcon : "religionPoints",
          },
        ],
      },
      {
        id: 6,
        buttonClicked: false,
        title: "איכות הסביבה",
        mapLayerName: "environment",
        showSubLayers: false,
        children: [
          {
            id: 61,
            title: "הכל",
            mapLayerName: "all",
          },
          {
            id: 62,
            title: "אנטנות סלולאריות",
            mapLayerName: "antennas",
            layerIcon : "antennas",
          },
          {
            id: 63,
            title: "זיהום סביבתי",
            mapLayerName: "pollution",
            layerIcon : "pollution",
          },
        ],
      },
    ],

    years_all_3: {
      data_neigh: [],
      data_setl: [],
      data_country: [],
    },
    years_all_4: {
      data_neigh: [],
      data_setl: [],
      data_country: [],
    },
    years_all_5: {
      data_neigh: [],
      data_setl: [],
      data_country: [],
    },
    years_all: {
      data_neigh: [],
      data_setl: [],
      data_country: [],
    },
    processing: false,
    graph_card: {
      chart: null,

      toggle_exclusive: 0,

      lastQuarterlyAvgPrice: null,
      lastQuarterlyAvgPrice_3: null,
      lastQuarterlyAvgPrice_4: null,
      lastQuarterlyAvgPrice_5: null,

      lastYearAvgPrice: null,
      lastYearAvgPrice_3: null,
      lastYearAvgPrice_4: null,
      lastYearAvgPrice_5: null,

      priceDifferencePercentage: null,
      priceDifferencePercentage_3: null,
      priceDifferencePercentage_4: null,
      priceDifferencePercentage_5: null,

      rooms_all: true,
      rooms_3: false,
      rooms_4: false,
      rooms_5: false,

      years_all_3: {
        data_neigh: [],
        data_setl: [],
        data_country: [],
      },
      years_all_4: {
        data_neigh: [],
        data_setl: [],
        data_country: [],
      },
      years_all_5: {
        data_neigh: [],
        data_setl: [],
        data_country: [],
      },
      years_all: {
        data_neigh: [],
        data_setl: [],
        data_country: [],
      },   
    },
    // end of data
  },
  getters: {},
  mutations: {
    async setLogin(state) {
      alert("setLogin");
      fetch("https://randomuser.me/api/")
        .then((response) => response.json())
        .then((data) => {
          alert("user", data.results[0].id.value);
          state.currentUser = {
            userid: data.results[0].login.uuid,
            username: data.results[0].login.username,
            first_name: data.results[0].name.first,
            last_name: data.results[0].name.last,
            addressList: [],
          }   
        });


      // set vue router to the MemberView (/?view=member)
      //router.push({ name: "member" });
      // refresh the page
      //location.reload();


    

    },
    setConfig(state, config) {
      const url = window.location.href;
      if (url.includes("localhost") || url.includes("dev.nadlan.gov.il")) {
        if (Object.prototype.hasOwnProperty.call(config, "s3_page_base")) {
          if (config.s3_page_base == "https://d30nq1hiio0r3z.cloudfront.net/api/pages") {
            config.s3_page_base = "https://d30nq1hiio0r3z.cloudfront.net/testing/api/pages";
          }
        }
        if (Object.prototype.hasOwnProperty.call(config, "s3_url_base")) {
          if (config.s3_url_base == "https://d30nq1hiio0r3z.cloudfront.net/api") {
            config.s3_url_base = "https://d30nq1hiio0r3z.cloudfront.net/testing/api";
          }
        }

      }
      state.config = config;
    },
    setNeigh(state, neigh) {
      state.neigh = neigh;
    },
    setSetlTypes(state, setlTypes) {
      state.setlTypes = setlTypes;
    },
    setPreviousRoute(state, route) {
      state.previousRoutes = [state.previousRoutes.pop(), route];
    },
  },
  actions: {
    async logIn({ commit }) {
      commit("setLogin");
    },
    async loadConfig({ commit }) {
      try {
        const response = await axios.get("/config.json");
        commit("setConfig", response.data);
      } catch (error) {
        console.error("Error loading config.json:", error);
      }
    },
    async loadNeigh({ commit }) {
      try {
        const conf_res = await axios.get("/config.json");
        const conf = conf_res.data;
        const response = await axios.get(
          conf.s3_url_base + "/index/neigh.json",
        );
        commit("setNeigh", response.data);
      } catch (error) {
        console.error("Error loading neigh.json:", error);
      }
    },
    async loadSetlTypes({ commit }) {
      try {
        const conf_res = await axios.get("/config.json");
        const conf = conf_res.data;
        const response = await axios.get(
          conf.s3_url_base + "/index/setl_types.json",
        );
        commit("setSetlTypes", response.data);
      } catch (error) {
        console.error("Error loading setlTypes.json:", error);
      }
    },
    async loadConfigAndNeigh({ commit }) {
      try {
        // Fetch the config file
        const conf_res = await axios.get("/config.json");
        const conf = conf_res.data;
        // Save config to the store
        commit("setConfig", conf);
  
        // Fetch the neighborhood data using the config
        const response = await axios.get(conf.s3_url_base + "/index/neigh.json");
        // Save neighborhood data to the store
        commit("setNeigh", response.data);
        
      } catch (error) {
        console.error("Error loading config and neigh.json:", error);
      }
    },
    
  },
  modules: {},
});
